import React, { Fragment, useEffect, useState } from 'react'

import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'

import ContactCounselorModal from 'components/ContactCounselorModal'

const ContactCounselor = ({ highSchoolId, onOpenChange, highSchoolName, contactUserId, ...rest }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    onOpenChange?.(open)
  }, [open])

  const onClose = (_, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') setOpen(false)
  }
  return (
    <Fragment>
      <Button
        {...rest}
        onClick={() => {
          setOpen(true)
        }}
      />
      <ContactCounselorModal
        open={open}
        handleClose={onClose}
        highSchoolId={highSchoolId}
        highSchoolName={highSchoolName}
        contactUserId={contactUserId}
      />
    </Fragment>
  )
}

ContactCounselor.propTypes = {
  children: PropTypes.any.isRequired,
  highSchoolId: PropTypes.string.isRequired,
  highSchoolName: PropTypes.string.isRequired,
  contactUserId: PropTypes.string,
  onOpenChange: PropTypes.func,
}

export default ContactCounselor
